export default "__VITE_ASSET__18aeb8f9__"